import React from 'react';
import {
  Box,
  Chip,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { formatDate } from '../../Pages/homePageUtils';
import { getActivityName } from '../../services/activityService';
import { getTrainingClassLabel } from '../../services/trainingClassService';

export default function DesktopRecentSessionsTable({
  recentSessions,
  openRows,
  onToggleRow,
  activityNamesById,
  trainingClassesByName,
}) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="recent training sessions table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Date</TableCell>
            <TableCell>Class</TableCell>
            <TableCell align="right">Duration (min)</TableCell>
            <TableCell align="right">Intensity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {recentSessions.map((session) => {
            const activities = session?.SessionActivity || [];
            const hasActivities = activities.length > 0;
            const isOpen = !!openRows[session.id];

            return (
              <React.Fragment key={session.id}>
                <TableRow>
                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={() => onToggleRow(session.id)}
                      disabled={!hasActivities}
                      aria-label={`toggle activities for session ${session.id}`}
                    >
                      {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                  </TableCell>
                  <TableCell>{formatDate(session.sessionDate)}</TableCell>
                  <TableCell>{getTrainingClassLabel(trainingClassesByName, session.sessionClass)}</TableCell>
                  <TableCell align="right">{session.durationMinutes ?? '-'}</TableCell>
                  <TableCell align="right">{session.intensity ?? '-'}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                      <Box className="activity-collapse">
                        {activities.map((activity) => (
                          <Paper key={activity.id} variant="outlined" className="activity-item">
                            <Typography variant="subtitle2">
                              {getActivityName(activityNamesById, activity.activityId)}
                            </Typography>
                            <Box className="activity-meta">
                              <Chip
                                size="small"
                                label={`Duration: ${activity.durationMinutes ?? 0} min`}
                              />
                            </Box>
                            {activity.notes ? (
                              <Typography variant="body2">{activity.notes}</Typography>
                            ) : (
                              <Typography variant="body2" color="text.secondary">
                                No activity notes.
                              </Typography>
                            )}
                          </Paper>
                        ))}
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
